import buttonStyles from "../../components/atoms/Button/Button.module.css";
import styles from "../../components/atoms/SideBar/SideBar.module.css";
import classNames from "classnames";
import { motion } from "framer-motion";
import { render } from "react-dom";
import { useEffect, useState } from "react";


export const SectionAccordion = ({
  children = null,
  content = null,
  moreButtonText,
  lessButtonText,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={classNames(styles.sectionAccordionWrapper)}>
      {content && (
        <motion.div
          className={classNames("section-accordion-inside", isOpen && "isopen")}
          animate={{ height: isOpen ? "fit-content" : 0 }}
          transition={{ stiffness: 1, duration: 0.5 }}
          dangerouslySetInnerHTML={{ __html: content || null }}
          {...props}
        ></motion.div>
      )}

      {children && (
        <motion.div
          className={classNames("section-accordion-inside", isOpen && "isopen")}
          animate={{ height: isOpen ? "auto" : 0 }}
          transition={{ stiffness: 1, duration: 0.5 }}
          {...props}
        >
          {children}
        </motion.div>
      )}

      <div className={`section-accordion-spacer ${isOpen && "open"}`} />

      <button className={buttonStyles.chevron} onClick={toggleOpen}>
        {isOpen ? lessButtonText : moreButtonText}

        <svg
          width="6"
          height="10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ transform: `rotate(${isOpen ? "270deg" : "90deg"})`, top: `${isOpen ? '0.2px' : '0.4px'}` }}
        >
          <path
            d="M1.5.75 5.25 4.5 1.5 8.25"
            stroke="#84BD00"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
};

export const useSectionAccordionWrapper = () => {
  useEffect(() => {
    const sectionAccordions = Array.from(
      document.querySelectorAll(".section-accordion")
    );

    // loop through each accordion on the page
    sectionAccordions.forEach((section) => {
      const content = section.querySelector("div:first-child")?.innerHTML;
      const [readMoreText = "Read More", readLessText = "Read Less"] =
        section
          ?.querySelector("button.button")
          ?.innerHTML.toString()
          .split("|") || [];

      if (content) {
        return render(
          <SectionAccordion
            content={content}
            moreButtonText={readMoreText}
            lessButtonText={readLessText}
          />,
          section
        );
      }
       
    });
  }, []);
};
